import { Url } from '../shared/Url';
import Post from '../shared/Post';
import PostXls from '../shared/PostXls';
import PostXlsUpload from '../shared/PostXlsUpload';

import { consultaUser } from './PefilFunction';
import { cookieData } from '../funciones/ConsultaUser';

export const ConsultaMisSecciones = (respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario,
        }

        
        Post(`${Url}misSecciones`, Content, (resp) => {
            let data = JSON.parse(resp);

            let contenido = []
            for (let i in data[0]) {
                contenido.push({
                    value: data[0][i].id,
                    label: `${data[0][i].carrera_name} ${data[0][i].semestre_name} [${data[0][i].materia_name} - ${data[0][i].nombre}]`,
                    carrera: data[0][i].carrera_name,
                    semestre: data[0][i].semestre_name,
                    seccion: `${data[0][i].materia_name} - ${data[0][i].nombre}`,
                    materia: data[0][i].materia_name,
                    seccioName: data[0][i].nombre,
                    codigo: data[0][i].codigo,
                    semestreNum: data[0][i].semestre_num,
                    cuantitativo: data[0][i].cuantitativo,
                })
            }
            respuesta([contenido, data[1]])
        });

    });
}

export const EstPorSeccion = (seccion, respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            seccion: seccion,
            user: usuario
        }
    
        
        Post(`${Url}estPorSeccion`, Content, (resp) => {
            let data = JSON.parse(resp);
            let data2 = data[0];
            let masculino = 0;
            let femenino = 0;

            for (let i in data2) {
                if (data2[i].sexo === "M") masculino++;
                if (data2[i].sexo === "F") femenino++;
            }

            let EstGender = {masculino, femenino}

            respuesta([data2, EstGender])
        });
    });
}

export const ConsultaCortes = (respuesta) => {
    Post(`${Url}prefCortes`, "", (resp) => {
        let data = JSON.parse(resp);
        let corteHab = data[0];
        let porcentaje = data[1];
        
        let contenido = [];
        for (let i in corteHab) {
            let label = "";
            let codigo = "";
            let percent = 0;
            switch (i) {
                case "hab_corte_1":
                    label = 'Corte 1';
                    codigo = 'corte_1';
                    percent = porcentaje.p_corte_1;
                    break;
                case "hab_corte_2":
                    label = 'Corte 2';
                    codigo = 'corte_2';
                    percent = porcentaje.p_corte_2;
                    break;
                case "hab_corte_3":
                    label = 'Corte 3';
                    codigo = 'corte_3';
                    percent = porcentaje.p_corte_3;
                    break;
                case "hab_corte_4":
                    label = 'Corte 4';
                    codigo = 'corte_4';
                    percent = porcentaje.p_corte_4;
                    break;
                case "hab_corte_5":
                    label = 'Corte 5';
                    codigo = 'corte_5';
                    percent = porcentaje.p_corte_5;
                    break;
                default:
                    label = '';
                    codigo = "";
                    percent = 0;
                    break;
            }

            if (corteHab[i] === 1) contenido.push(
                { value: i , label:`${label} - ${percent}%`, codigo: codigo }
            )            
        }

        respuesta(contenido)
    });
}

export const updCalif = (calif, corte, est, seccion, respuesta) => {

    if (calif === "") return null;

    let errores = 0;
    let mensaje = {
        status: "",
        mensaje: ""
    };

    let icono = {
        icon: "fa fa-check",
        color: "#32704C" 
    }

    let modalidad = "";

    /* Consultar modalidad */
    let Seccion = { id: seccion }
    Post(`${Url}consultaModalidad`, Seccion, (mod) => {
        let dataMod = JSON.parse(mod);
        modalidad = dataMod[0][0];

        if (modalidad.cualitativo === 1) cualitativo();
        if (modalidad.cuantitativo === 1) cuantitativo(modalidad.nota_max);

    });

    let text = calif;

    let campoVacio = (campo, mensaje) => {
        if (campo === "") {
            mensaje = {
                status: "error",
                mensaje: mensaje
            };
            text = "";
            icono = {
                icon: "fa fa-times",
                color: "#A0555C" 
            };
            errores ++;
        }
    }

    let cualitativo = () => {
        campoVacio (corte, "Debes seleccionar un corte de notas")
        campoVacio (est, "Ningún estudiante seleccionado")
        campoVacio (seccion, "Ninguna sección seleccionada")   

        if (errores === 0) {
            consultaUser ((usuario) => {
                let Content = {
                    id: usuario,
                    seccion: seccion,
                    est: est,
                    corte: corte,
                    calif: calif
                }
        
                Post(`${Url}updCalif`, Content, () => {
                    respuesta([text, mensaje, icono])
                });
            });
        }else{
            respuesta([text, mensaje, icono])
        }
    }


    let cuantitativo = (max) => {

        /* VALIDACIONES */
        /* if (!isNaN(Number(calif)) === false){ */
        if (!/^([0-9])*$/.test(calif)){
            mensaje = {
                status: "error",
                mensaje: "Debes colocar solo números para para esta asignatura"
            };
            text = "";
            calif = "";
            icono = {
                icon: "fa fa-times",
                color: "#A0555C" 
            };
            errores ++;
        }

        campoVacio (corte, "Debes seleccionar un corte de notas")
        campoVacio (est, "Ningún estudiante seleccionado")
        campoVacio (seccion, "Ninguna sección seleccionada")        
        if (calif > parseInt (max)) text = max;
        
        /* AÑADIR EL CERO AL LAS CALIFICACIONES MENORES DE 10 */
        if (calif < 10 && calif > 0) text = (`0${calif}`).substr(-2);
        
        if (calif === "0" || calif === "00" || calif === "000"){
            text = "";
            calif = "";
        }

        if (errores === 0) {
            consultaUser ((usuario) => {
                let Content = {
                    id: usuario,
                    seccion: seccion,
                    est: est,
                    corte: corte,
                    calif: calif
                }
        
                Post(`${Url}updCalif`, Content, () => {
                    respuesta([text, mensaje, icono])
                });
            });
        }else{
            respuesta([text, mensaje, icono])
        }
    }
}

export const ConsultCalif = (seccion, est, corte, respuesta) => {
    let campo = corte.substr(4);
    consultaUser ((usuario) => {
        let Content = {
            id: usuario,
            seccion: seccion,
            est: est,
            corte: campo,
        }

        Post(`${Url}consultCalif`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    });
}

export const RendimientoXls = (seccion, seccion_name, respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            seccion: seccion,
            usuario: usuario
        }
        PostXls(`${Url}xlsRendimiento`, Content, `Rendimiento - [${seccion_name}]`,(resp) => {
            respuesta(resp)
        }); 
    });
}

export const RendimientoXlsDir = (usuario, seccion, seccion_name, respuesta) => {
    let Content = {
        seccion: seccion,
        usuario: usuario
    }
    PostXls(`${Url}xlsRendimiento`, Content, `Rendimiento - [${seccion_name}]`,(resp) => {
        respuesta(resp)
    }); 
}

export const UploadXls = (file, seccion, corte, respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            seccion: seccion,   
            corte: corte
        }

        PostXlsUpload(`${Url}uploadCalifXls`, file, Content, usuario, (resp) => {
            respuesta(resp)
        });
    });
}


// WEBPACK FOOTER //
// ./src/funciones/CalifFunction.jsx